module.exports = require('./dist/timeout')
